export const getFieldValue = (value: string | number | undefined) => value ?? '';
